import SharedController from "./SharedController";
import UrlController from "../controller/UrlController";
import Renderer from "../Renderer";
import Utils from "../utils/Utils";

/**
 * The frontend will create InlineController for starting the spreads inline
 * @creator Stefano
 * @date 26-6-2018
 */
export default class OfflineController extends SharedController {
    constructor(fc) {
        super();
        this.fc = fc;
        // this.init();

        // this.fc.interface.setTransitionSlider();
        // this.fc.interface.InterfaceTransitions.init();
        this.urlListener = false;
    }

    hasUrlListener() {
        return this.urlListener;
    }

    bindNavigationButtons() {
        $(".maglr-navigation")
            .off("click")
            .on("click", (event) => {
                event.preventDefault();
                let spread_id = $(event.currentTarget).attr("href");
                this.fc.resolveSpreadToIndex(spread_id);
            });
    }

    init() {
        if (window.issue_settings != undefined) {
            // this.issue_settings = window.issue_settings;
            // let issue_id = window.issue_settings.issue_id;
            // let new_obj = {};
            // new_obj[issue_id] = window.issue_settings;
            // this.fc.dataHelper._setIssues( new_obj );
            // this.startIssue( );
            this.loadIssueSettings();
        } else {
            Utils.AjaxPromise({ url: "issue.js" })
                .then(
                    () => {
                        this.loadIssueSettings();
                    },
                    () => {
                        console.error("MAGLR ERROR: Ajax error createIssue");
                        // alert( "Ajax error createIssue" );
                    },
                )
                .catch((error) => {
                    console.error("MAGLR ERROR: [createIssue]", error);
                    // alert( "Promise error createIssue" );
                });
        }
    }

    loadIssueSettings() {
        this.issue_settings = window.issue_settings;
        let issue_id = window.issue_settings.issue_id;
        let new_obj = {};
        new_obj[issue_id] = window.issue_settings;
        this.fc.dataHelper._setIssues(new_obj);
        this.fc.dataHelper.createCompleteUrlList();
        this.startIssue();
    }

    fetchInlineSpreadSettings(client_id, issue_id, spread_id) {
        this.fc.setSpreadStatus(spread_id, this.fc.SPREADSTATUSLIST.INIT);
        if (this.checkInlinePossible(spread_id, issue_id)) {
            //Niet meer nodig denk /26-juni-2020
            this.fc.createSpreadContainer(spread_id);

            if (this._spread_settings[spread_id]) {
                this.fc.initSpread(spread_id, this._spread_settings[spread_id]);
            } else {
                Utils.AjaxPromise({ url: `${spread_id}.js` })
                    .then(
                        (data) => {
                            this._spread_settings[spread_id] = eval(data);
                            this.fc.initSpread(spread_id, this._spread_settings[spread_id]);
                        },
                        () => {
                            console.error("MAGLR ERROR: Ajax error fetchSpreadSettings");
                        },
                    )
                    .catch((error) => {
                        console.error("MAGLR ERROR: [fetchSpreadSettings]", error);
                    });
            }
        } else {
            this.fc.initSpread(spread_id);
        }

        // return this.fetchSpreadSettings(spread_id);
    }

    checkInlinePossible(spread_id) {
        let inline_spreads = this.fc.getDataHelper().inline_spreads;
        if (inline_spreads.indexOf(spread_id) > -1) {
            return true;
        }
        if (this.fc.getSpreadType(spread_id) === 2 && this.fc.getSpreadAssetsVersion(spread_id) > 9) {
            inline_spreads.push(spread_id);
            return true;
        }
        return false;
    }

    fetchSpreadSettings(spread_id, init, immediately) {
        if (init) {
            this._renderSpreads();
        }

        this.fc.createSpreadContainer(spread_id);
        this.fc.fetchSpreadProxy(spread_id, immediately);
    }

    findSpreadById(spread_id) {
        for (var i in this.issue_settings.spreads) {
            if (this.issue_settings.spreads[i].spread_id == spread_id) {
                return this.issue_settings.spreads[i];
            }
        }
    }

    resetSpreads() {
        try {
            this.fc.advancedController.resetSpreads();
        } catch {
            // continue regardless of error
        }
        try {
            this.fc.iframeController.resetSpreads();
        } catch {
            // continue regardless of error
        }
    }
    checkUrlName() {
        let urlPath = location.pathname.substr(1);
        let urlSpread = urlPath.split("/").slice(-2).join("/");
        let list = window.frontend.dataHelper.getUrlList();
        let spread = list[urlSpread] ?? list[urlSpread.replace(".html", "")];
        let offset = list[urlPath] ?? list[urlPath.replace(".html", "")];
        let url = spread ? urlSpread : urlPath;

        return { url: url, value: spread ?? offset };
    }
    detectPossibleSpread() {
        let checkUrl = this.checkUrlName();

        let spread_id;
        if (checkUrl.value && Object.hasOwn(checkUrl.value, "spread_id")) {
            spread_id = checkUrl.value.spread_id;
            if (window.downloaded == 1) {
                self.urlOffset = location.pathname.replace(checkUrl.url, "").replace(/^\/|\/$/g, ""); //remove trailing or starting slashes
            }
        } else if (self._first != undefined && self._first.spread_id != undefined) {
            spread_id = self._first.spread_id;
        } else {
            spread_id = this.issue_settings.spreads[0].spread_id;
        }

        return spread_id;
    }

    setupIssueSpread() {
        let spread_id = this.detectPossibleSpread();
        let issue_id = this.issue_settings.issue_id;

        let hash = Utils.getLocationHash();

        if (!isNaN(hash)) {
            spread_id = hash;
        }

        // this.fc.setSpreadId(issue_id, spread_id);
        // this.fc.setCurrentIssueId(issue_id);
        // this.fc.setCurrentSpreadId(spread_id);
        this._spread_settings = window._spreads || [];

        return { issue_id: issue_id, spread_id: spread_id };
    }

    initStep() {
        let spread_id = this.fc.getCurrentSpreadId();
        this._renderSpreads();
        // this.fc.interface.firstPage();
        // this.fc.gotoSpread();
        // this.fc.interface.renderSpreadNavigationList( spreads , this.issue_settings );
        // this.bindNavigationButtons();
        // this.fetchSpreadSettings(spread_id);
        // this.fc.interface.loadPages(this.fc.spreadOrder);
        this.fc.interface.setPageNumber();
        if (spread_id) {
            this.fc.moveSpreadToMainStage(spread_id);
        }
    }

    startIssue() {
        try {
            let IDS = this.setupIssueSpread();

            if (self.urlOffset != undefined && self.downloaded === 1) {
                this.urlController = new UrlController(this.fc, window.urlOffset);
                // this.fc.setCurrentIssueId(0);
                // this.fc.setCurrentSpreadId(0);
                this.urlListener = true;
                this.urlController.bindUrlListener();
                self.downloaded = 0;
            } else {
                if (IDS.spread_id) {
                    this.fc.setCurrentIssueId(IDS.issue_id);
                    this.fc.setCurrentSpreadId(IDS.spread_id);
                }
                this.initStep();
                Utils.setLocationHash(IDS.spread_id);
                // location.hash = IDS.spread_id;
                this.fetchSpreadSettings(IDS.spread_id);
                this.fc.setSpreadId(IDS.issue_id, IDS.spread_id);
                this.fc.fetchSpread(IDS.spread_id);
                if (this.fc.interface.storyMode) {
                    this.fc.interface.storyMode.stackShift(IDS.spread_id);
                }
            }
        } catch (error) {
            console.error("MAGLR ERROR: [startIssue]", error);
        }
    }

    /**
     * Renders the spreads from given issue with handlebars
     *
     * @private
     */
    _renderSpreads() {
        try {
            const dataHelper = this.fc.getDataHelper();
            const language = "nl_NL";
            const issue_id = this.fc.getCurrentIssueId();
            this.fc.interface.rendeSidePanelByIssueId(issue_id);
            this.fc.createSpreadOrder();

            const renderData = {
                spreads: dataHelper.filterAndOrderSpreads(issue_id),
                LANG: language,
                DATA_URL: window.data_domain,
                local: true,
            };
            try {
                let html = document
                    .getElementById("HB-spread")
                    .innerHTML.replace(
                        'data-src="{{cl_client_client_id}}/issues/{{js_issue_issue_id}}/{{spread_id}}/{{filename}}{{#unless filename}}index{{/unless}}.html"',
                        'data-src="{{spread_id}}/index_relative.html"',
                    );
                Renderer.registerPartial("spreadTemplate", html);
                // Renderer.registerPartial("issue_cover", document.getElementById("HB-issue-cover").innerHTML);
            } catch (error) {
                console.error("MAGLR ERROR: [offline.renderSpreads1]", error);
            }

            let spread_id = this.fc.getCurrentSpreadId();
            var current_spread = null;
            for (var i in renderData.spreads) {
                if (renderData.spreads[i].spread_id === spread_id) {
                    current_spread = renderData.spreads[i];
                    break;
                }
            }

            //handlebars
            const source = $("#HB-preload-spreads").html();
            current_spread.skip = true;
            const output = Renderer.renderSource(source, renderData);
            current_spread.skip = false;
            Renderer.nativeInject("content-loader", output);
        } catch (error) {
            console.error("MAGLR ERROR: [offline.renderSpreads2]", error);
        }
    }
}
